import React from 'react';
import { Grid, Label } from 'semantic-ui-react';
import InputField from 'common/InputField';
import ScriptEditor from './ScriptEditor';


const TrapEditor = function(props) {
  const trap = props.trap;
  const change = props.onChange;

  return (
  <React.Fragment>
    <Grid.Row>
      <Grid.Column width={3}>
        <InputField value={trap.Spot}
                    onChange={change('Spot')}
                    type='int'
                    fluid
                    label='Spot'
                    placeholder='Spot' />
      </Grid.Column>
      <Grid.Column width={3}>
        <InputField value={trap.Disarm}
                    onChange={change('Disarm')}
                    type='int'
                    fluid
                    label='Disarm'
                    placeholder='Disarm' />
      </Grid.Column>
      <Grid.Column width={10}>
        <Label>OnMove</Label>
        <ScriptEditor src={trap.OnMove}
                      onSave={change('OnMove')} />
      </Grid.Column>
    </Grid.Row>
  </React.Fragment>
  );
}



export default TrapEditor;
